"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlattenedCategories = void 0;
const getFlattenedCategories = (categories) => {
    const flattenedCategories = [];
    categories.forEach((category) => {
        flattenedCategories.push(category);
        category.childCategories.forEach((childCategory) => {
            flattenedCategories.push(childCategory);
        });
    });
    return flattenedCategories;
};
exports.getFlattenedCategories = getFlattenedCategories;
//# sourceMappingURL=index.js.map